import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function PackageIconLabel({ icon: Icon, label, testId }) {
    return (_jsxs("div", { className: "flex items-center gap-1.5", "data-testid": testId, children: [_jsx(Icon, { className: "text-brand size-5 shrink-0" }), _jsx("span", { className: "text-body text-sm leading-6", children: label })] }));
}
